export default __webpack_public_path__ + "static/benefit-1-bf1abadc25310cea8852e60c9b5e28ff.jpg";